import React from 'react';
import { ListGroupItem, Collapse } from 'reactstrap';

class ListGroupCollapse extends React.Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.props.toggle(this.props.content);
    }

    render() {
        const content = this.props.content;
        const icon = this.props.icon;
        return (
            <ListGroupItem>
                <div>
                    <p onClick={this.toggle} style={{cursor: 'pointer'}}>
                        <i className={icon}/>
                        <strong>{content.header}</strong>
                        <i className="float-right fas fa-caret-down"/>
                    </p>
                    <Collapse isOpen={this.props.isOpen} className="">
                        {content.content}</Collapse>
                </div>
            </ListGroupItem>
        );
    }
}

export default ListGroupCollapse